import { FlexRow } from '@/components/common/Flex';
import Icon from '@/components/common/icons/Icon';
import { FlexProps } from '@chakra-ui/react';
import { IconName } from '@common/react/icons';
import { FC } from 'react';
import { IconSVGComponentProps } from './icons/IconComponent';
import { Text } from './Typography';

export interface InfoTextProps extends FlexProps {
    color?: IconSVGComponentProps['color'];
    iconName?: IconName;
    size?: 'sm' | 'md';
}

const InfoText: FC<InfoTextProps> = ({
    iconName = 'InfoCircle',
    color = 'gray.500',
    size = 'md',
    children,
    ...rest
}) => {
    const { iconSize, fontSize } = {
        sm: { iconSize: 'sm', fontSize: 'sm' },
        md: { iconSize: 'md', fontSize: 'md' },
    }[size];

    return (
        <FlexRow {...rest}>
            <Icon name={iconName} size={iconSize} color={color} mr={2} />
            <Text fontSize={fontSize} color={color}>
                {children}
            </Text>
        </FlexRow>
    );
};

export default InfoText;
